import api from "../components/config/api_urls";


export function getRecursURL(recursos, tipus_recurs, idioma = "") {

  const recurs = recursos.find((e) => e.tipus_recurs === tipus_recurs)?.[
    `imatge_recurs${idioma}`
  ];

  if (!recurs) {
    if (idioma) {
      return alert(
        `Fa falta crear el recurs multimèdia ${tipus_recurs} amb l'idioma ${idioma}`,
      );
    }
    return alert(`Fa falta crear el recurs multimèdia ${tipus_recurs} `);
  }

  return api.api2_url + recurs.url;
}

export function getRecursText(recursos, tipus_recurs, idioma = "") {
  const recurs = recursos.find((e) => e.tipus_recurs === tipus_recurs)?.[
    `text_recurs${idioma}`
  ];

  if (!recurs) {
    if (idioma) {
      return alert(
        `Fa falta crear el recurs de text ${tipus_recurs} amb l'idioma ${idioma}`,
      );
    }

    return alert(`Fa falta crear el recurs de text ${tipus_recurs}`);
  }

  return recurs;
}

export function getMultimedia(item, camp) {
  const recurs = api.api2_url + item[camp]?.url;

  if (!item[camp]?.url) {
    return alert(`Fa falta pujar el multimèdia ${camp}. id: ${item.id}`);
  }

  return recurs;
}
